// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Navigation_navLink__1_Nr_","navLinkRed":"Navigation_navLinkRed__R0gby"};